var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlurEmerald1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1211,
    height: 1548,
    viewBox: "0 0 1211 1548",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_642_569)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M303.872 386.242C295.735 371.809 300.839 353.513 315.272 345.376L388.888 303.872C403.321 295.735 421.617 300.839 429.754 315.272L906.944 1161.68C915.081 1176.11 909.977 1194.41 895.545 1202.55L821.928 1244.05C807.496 1252.19 789.199 1247.08 781.062 1232.65L303.872 386.242Z",
    fill: "url(#paint0_linear_642_569)",
    fillOpacity: 0.4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_642_569",
    x: 0,
    y: 0,
    width: 1210.82,
    height: 1547.92,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 150,
    result: "effect1_foregroundBlur_642_569"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_642_569",
    x1: 247.728,
    y1: 272.931,
    x2: 762.412,
    y2: 1102.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#079743"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.631321,
    stopColor: "#7BD2A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#75CB99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B895C"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlurEmerald1);
export default __webpack_public_path__ + "static/media/blur-emerald-1.c5541681545df61920054f4d4f3edd40.svg";
export { ForwardRef as ReactComponent };